import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ClippingStudioSubtitleEvent } from "app/js/src/domain/clipping-studio/clipping-studio-project";

@Component({
  selector: "evrideo-clipping-studio-subtitle-block",
  templateUrl: "./clipping-studio-subtitle-block.component.html",
  styleUrls: ["./clipping-studio-subtitle-block.component.scss"],
})
export class ClippingStudioSubtitleBlockComponent {
  @Input() subtitle!: ClippingStudioSubtitleEvent;
  @Input() selected = false;
  @Output() select = new EventEmitter<string>();
  @Output() textChange = new EventEmitter<{ id: string; text: string }>();
  @Output() split = new EventEmitter<string>();
  @Output() delete = new EventEmitter<string>();

  get startTimeStr(): string {
    return this.formatMs(this.subtitle.StartTimeMS);
  }

  get endTimeStr(): string {
    return this.formatMs(this.subtitle.EndTimeMS);
  }

  onBlockClick(event: MouseEvent): void {
    event.stopPropagation();
    this.select.emit(this.subtitle.id);
  }

  onSplitClick(event: MouseEvent): void {
    event.stopPropagation();
    this.split.emit(this.subtitle.id);
  }

  onDeleteClick(event: MouseEvent): void {
    event.stopPropagation();
    this.delete.emit(this.subtitle.id);
  }

  private formatMs(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (n: number, len = 2) => n.toString().padStart(len, "0");
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
}
